export default function About() {
  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We constantly push boundaries to create cutting-edge solutions that meet evolving user needs'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Security',
      description: 'Your privacy and data protection are at the core of everything we develop'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centric',
      description: 'Every feature is designed with the end user in mind, ensuring intuitive and seamless experiences'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Performance',
      description: 'We optimize every aspect to deliver fast, reliable, and efficient applications'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About Articruz S A
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">
                <strong className="text-gray-900">Articruz S A</strong> is a dedicated team of experts specializing in the development of modern applications for the iOS platform. With years of experience and a passion for innovation, we create solutions that make a real difference in users' daily lives.
              </p>
              <p className="text-lg">
                Our flagship products, including our advanced VPN and intelligent Cleaner applications, are meticulously designed to enhance user experience while prioritizing security and performance. We understand the importance of mobile device optimization and privacy protection in today's digital landscape.
              </p>
              <p className="text-lg">
                At <strong className="text-gray-900">Articruz S A</strong>, we believe in combining technical excellence with user-friendly design. Our applications are built using the latest iOS technologies and best practices, ensuring they remain reliable, efficient, and ahead of the curve.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/be63aa653f93625ec9a38cc4fba023b0.jpg"
                alt="Articruz S A Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-500/10 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-emerald-500/10 rounded-2xl -z-10"></div>
          </div>
        </div>

        <div className="mt-20">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Our Core Values
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-gray-50 hover:bg-teal-50 transition-colors duration-300"
              >
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
